import { useI18n } from "@/lib/i18n";
import * as Icons from "lucide-react";

export default function ServicesGrid({ services = [] }) {
    const { t, pick } = useI18n();
    if (!services.length) return null;
    const Sparkles = Icons.Sparkles;

    return (
        <section id="leistungen" data-testid="services-section" className="bg-[#F8FAFC] py-24">
            <div className="max-w-7xl mx-auto px-5 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12">
                    <div className="max-w-2xl">
                        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-[#10B981]">
                            {t("sections.services_title")}
                        </div>
                        <h2 className="mt-2 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]">
                            {t("sections.services_sub")}
                        </h2>
                    </div>
                    <p className="text-[#64748B] max-w-md">
                        Problem · Lösung · Outcome — jede Leistung ist ein klares Versprechen.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {services.map((s, idx) => {
                        const Icon = (Icons[s.icon] || Sparkles);
                        const isFeatured = idx === 0 || idx === 4; // bento highlights
                        return (
                            <article
                                key={s.id || idx}
                                data-testid={`service-card-${s.id}`}
                                className={`bm-card relative rounded-3xl border border-[#E2E8F0] bg-white p-7 lg:p-8 ${isFeatured ? "lg:row-span-1" : ""}`}
                            >
                                <div className="flex items-start gap-4">
                                    <div className="size-11 rounded-2xl bg-[#0F172A] text-white flex items-center justify-center shrink-0">
                                        <Icon className="size-5" />
                                    </div>
                                    <div>
                                        <h3 className="font-display text-xl font-bold text-[#0F172A] tracking-tight">
                                            {pick(s.title)}
                                        </h3>
                                    </div>
                                </div>
                                <div className="mt-5 space-y-3 text-sm text-[#0F172A]">
                                    <Row label="Problem" tone="muted" value={pick(s.problem)} />
                                    <Row label="Lösung" tone="emerald" value={pick(s.solution)} />
                                    <Row label="Outcome" tone="champagne" value={pick(s.outcome)} />
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

function Row({ label, tone, value }) {
    const dot = tone === "emerald" ? "bg-[#10B981]" : tone === "champagne" ? "bg-[#C8A96B]" : "bg-[#64748B]";
    return (
        <div className="flex items-start gap-3">
            <span className={`mt-1.5 inline-block size-2 rounded-full ${dot}`} />
            <div className="flex-1">
                <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#64748B]">{label}</div>
                <div className="mt-0.5 leading-relaxed">{value}</div>
            </div>
        </div>
    );
}
